<template>

	<div class="main-contents">
		<div class="mem_container prj_sp">
			<!-- <div class="myp-banner">
				<img src="/images/guide_banner.png" alt="상단배너"/>
			</div>		 
			-->
			
			<div style="display: flex; width: 1200px; margin: 0 auto;">
				<div class="contents-body demand tab flex mx-0">
					<ProjectInfo :projectSeq="projectSeq" type="5" @goList="$router.go(-1)" @prjSideInfo="setPrjSideInfo" ref="updatePrjInfo"/>					
				</div>				

				<div class="sticky-btn">
					<div class="recruit">
						<div v-if="(prjSideInfo.projectAppSeq != undefined && prjSideInfo.projectAppSeq != '') || (prjSideInfo.projectInterviewIng != undefined && prjSideInfo.projectInterviewIng != '')" class="btn_gray">지원완료</div> 
						<div v-else-if ="(prjSideInfo.recrCloseYn == 'Y')" class="btn_gray">바로 지원하기</div> 
						<div v-else class="btn_blue" @click="insertApp()">바로 지원하기</div>   
						
						<div v-if="prjSideInfo.interestYn == 'Y'" @click="deleteInterestProject()">							
							<img  src="/images/tec/prj/heart_01.png" alt="관심등록클릭후" style="width: 20px; margin-right: 4px;"/> 
							관심 프로젝트
						</div>
						<div v-else @click="insertInterestProject()">							
							<img src="/images/tec/prj/heart_00.png" alt="관심등록클릭전" style="width: 20px; margin-right: 4px;"/> 
							관심 프로젝트
						</div>
					</div>

					<div class="deadline flex-col px-0 py-0">
						<div v-if="prjSideInfo.recrEndDateDiff >= 0">
							<span class="date">
								<img src="/images/tec/prj/date_color.png" alt="마감기간"/> 
								마감 <span class="period">{{prjSideInfo.recrEndDateDiff}}</span> 일 전
								<!-- 모집마감 -->
							</span>
						</div>
						<div>
							<span>
								<img src="/images/tec/prj/member_sm.png" alt="지원자수"/>
								지원 IT프로 <span class="member">{{prjSideInfo.appCount}}</span> 명
							</span>
						</div>
					</div>

					<div class="management"> 
						<div class="profile">
							프로젝트 지원을 위해 <br />
							이력서 작성, 증명서 등록, <br />
							NCS 직무자가평가를 완료해 주세요.
							<span>
								<a href="javascript:void(0);" @click="pageMove('PRF101M01')">내 프로필 바로가기 &gt;</a>
							</span>
						</div>
						<div class="manager">
							<span>
								담당 매니저 <strong>{{prjSideInfo.admMgrMberNm}}</strong>
							</span>
							IT프로를 위한 전담매니저가 <br />
							얼라이언스 전 과정을 지원해 드립니다.
						</div>
					</div>
				</div>
			</div>
			<div class="btn-prj-detail" @click="$router.go(-1)">
				<span class="btn-list">
					&lt; 목록보기
				</span>
			</div>
		</div>
	</div>

</template>

<script>

import ProjectInfo from '@/components/highpro/ProjectInfo.vue';

export default {

	components : {
		ProjectInfo
	},

	data() {
		return {
			projectSeq : 0,
			prjSideInfo : {}
		};
	},
	beforeCreate() {
		// console.log('beforeCreate');
	},
	created() {
		// console.log('created');
	},
	beforeMount() {
		// console.log('beforeMount');
		if(this.$route.query.projectSeq != undefined && this.$route.query.projectSeq != '') {
			this.projectSeq = Number(this.$route.query.projectSeq);
		}		
	},
	mounted() {
		// console.log('mounted');
	},
	beforeUpdate() {
		// console.log('beforeUpdate');
	},
	updated() {
		// console.log('update');
	},
	beforeDestroy() {
		// console.log('beforeDestroy');
	},
	destroyed() {
		// console.log('destroyed');
	},

	props: { type : String },
	methods: {
		pageMove(name) {
			// console.log('name', name);
			this.$router.move(name);
		},

		// 프로젝트정보
		setPrjSideInfo(prjSideData){
			this.prjSideInfo = prjSideData;
			// console.log(this.prjSideInfo)
		},

		// 프로젝트 지원하기
        insertApp() {
            this.$.popup('/tec/prj/PRJ101P02', { 
                        projectSeq : this.prjSideInfo.projectSeq, 
                        projectNm: this.prjSideInfo.projectNm, 
                        projectRecrFieldList: this.prjSideInfo.projectRecrFieldList, 
                        projectDtlDesc : this.prjSideInfo.projectDtlDesc,
                        clientNm : this.prjSideInfo.clientNm,
                        projectLocCont : this.prjSideInfo.projectLocCont,
                        corpNm : this.prjSideInfo.corpNm,
                        corpMgrMberNm : this.prjSideInfo.corpMgrMberNm,
                        gubun: 'insert'})
                .then(res => {
                    //console.log(res);
                    if(res === true) {
                        alert("지원이 완료되었습니다.");
                        this.$refs.updatePrjInfo.getProjectInfo();
                    } else if(res == "asgReqFalse") {
                        alert("아직 소속사 신청을 하지 않아 지원을 하실 수 없습니다.\n소속사 신청이 승인된 이후 지원해주세요.");
                    }else if(res == "asgApprFalse") {
                        alert("아직 소속사 승인이 되지 않아 지원을 하실 수 없습니다.\n소속사 신청이 승인된 이후 지원해주세요.");
                    }else if(res == "techGradeFalse") {
                        alert("아직 기술등급이 확정되지 않아 지원을 하실 수 없습니다.\n기술등급이 확정된 이후 지원해주세요.\n※기술등급 확정까지 1일~3일 소요됩니다.");
                    }
                });
        },

		// 관심프로젝트 등록
        insertInterestProject() {
		this.$.popup('/tec/prj/PRJ101P01', { projectSeq : this.prjSideInfo.projectSeq, projectNm: this.prjSideInfo.projectNm, gubun: 'insert', recrCloseYn : this.prjSideInfo.recrCloseYn})
			.then(res => {
				if(res) {
					this.$refs.updatePrjInfo.getProjectInfo();
				}
			});
		},

		// 관심프로젝트 삭제
		deleteInterestProject() {
		this.$.popup('/tec/prj/PRJ101P01', { projectSeq : this.prjSideInfo.projectSeq, projectNm: this.prjSideInfo.projectNm, gubun: 'delete'})
			.then(res => {
				if(res) {
					this.$refs.updatePrjInfo.getProjectInfo();
				}
			});
		},        

	}
};
</script>
